import React from 'react'
export default function CalendarIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 18">
            <path fillRule="evenodd" d="M4.8.6c.2 0 .4.2.4.4v1.2h5.6V1a.4.4 0 0 1 .8 0v1.2H13c.4 0 .7.1 1 .3.6.3 1 .7 1.3 1.2l.3 1.1v10c0 .4-.1.7-.3 1-.3.6-.7 1-1.2 1.3l-1.1.3H3c-.4 0-.7-.1-1-.3-.6-.3-1-.7-1.3-1.2l-.3-1.1v-10c0-.4.1-.7.3-1 .3-.6.7-1 1.2-1.3L3 2.2h1.4V1c0-.2.2-.4.4-.4ZM4.4 3H3.1l-.8.2a2 2 0 0 0-.9.9l-.2.8V7h13.6V5l-.2-.8a2 2 0 0 0-.9-.9L13 3h-1.3v1.2a.4.4 0 1 1-.8 0V3H5.2v1.2a.4.4 0 1 1-.8 0V3Zm10.4 4.8H1.2v6.9l.2.8c.2.4.5.7.9.9l.8.2h9.8l.8-.2c.4-.2.7-.5.9-.9l.2-.8V7.8Z" clipRule="evenodd"/>
        </svg>
    )
}


